<script setup lang="ts">
import { Analytics } from '@vercel/analytics/nuxt'
import { SpeedInsights } from '@vercel/speed-insights/vue'

useHead({ htmlAttrs: { lang: 'pt-BR' } })
useSeoMeta({
  ogImage: '/images/strassen-logo.png',
  ogImageAlt: 'Strassen · Desenvolvimento de Software',
  title: 'Strassen · Desenvolvimento de Software | Websites que Aumentam Vendas',
  ogTitle: 'Strassen · Desenvolvimento de Software | Websites que Aumentam Vendas',
  description: 'Criamos websites profissionais para empresas e profissionais que querem aumentar suas vendas. Desenvolvimento de software focado em resultados e conversão.',
  ogDescription: 'Criamos websites profissionais para empresas e profissionais que querem aumentar suas vendas. Desenvolvimento de software focado em resultados e conversão.',
  keywords: 'desenvolvimento de software, criação de sites, websites profissionais, aumento de vendas, desenvolvimento web, sites para empresas, conversão digital',
})
</script>

<template>
  <div class="bg-background text-foreground antialiased scroll-smooth">
    <Analytics />
    <SpeedInsights />
    <NuxtRouteAnnouncer />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
